// Duplicated from ab-common
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { notesListSelector, privateNotes, publicNotes } from "../store/selectors/application";
import { notesAlertOnlySelector } from '@applyboard/ab-common';
var notesListingProps = createStructuredSelector({
  notes: notesListSelector,
  public_notes: publicNotes,
  private_notes: privateNotes,
  with_alert_only: notesAlertOnlySelector
});
var notesListingEnhancer = connect(notesListingProps);
export default notesListingEnhancer;